import React from 'react';
// Icons
import { FaXTwitter } from 'react-icons/fa6';
import { CompanyName, LocationCity, TWITTER_URL } from '../../utils/Constants';

function SmallSocialCta() {
  return (
    <section className='grid w-full'>
      <article className='grid justify-center text-center px-6'>
        <div>
          <p className='text-3xl md:text-5xl md:mb-2 font-titleFont'>
            Follow Me on Twitter
          </p>
        </div>
        <div className='grid justify-center py-6'>
          <a
            href={TWITTER_URL}
            target='_blank'
            rel='noreferrer'
            aria-label='Link to Twitter'
            className='text-colour1 text-3xl'
          >
            <FaXTwitter />
          </a>
        </div>
        <div className='font-semibold'>{CompanyName}</div>
        <div className='text-sm text-colour1'>{LocationCity}</div>
        <div className='text-sm text-colour1 mt-4'>
          © {new Date().getFullYear()} {CompanyName}. All rights reserved.
          <br />
          Unauthorized use or reproduction of content is strictly prohibited.
        </div>
      </article>
    </section>
  );
}

export default SmallSocialCta;
